/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs */



/**
* | output |
* | --- |
* | "Event group not found" |
*
* @param {Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_export_event_group_not_found_error = /** @type {((inputs?: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'evenements introuvable")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppe nicht gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi non trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа событий не найдена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos no encontrado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de eventos não encontrado")
	return /** @type {LocalizedString} */ ("Event group not found")
});